module.exports = __webpack_public_path__ + "img/business-consulting.6814b1c3.png";